export default __webpack_public_path__ + "static/media/thumbnil4.dd224b66.png";